package com.yogaaicoach.pages.payment.ui

enum class SubscriptionPlan(val title: String, val price: String) {
    MONTHLY("Monthly", "4.99€/month"),
    YEARLY("Yearly", "29.99€/year");

    companion object {
        fun fromTitle(title: String?): SubscriptionPlan? {
            return title?.let { inputTitle ->
                entries.firstOrNull { it.title.equals(inputTitle, ignoreCase = true) }
            }
        }
    }
}